<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-envelope"></i> {{  "BUTTON.FORWARD-URL" | translate }}</h4>
    </div>
    <div class="modal-body">
        <div class="table-responsive">
            <table class="table-sm">
                <thead class="custom-font-size-table-header">
                <tr>
                    <th scope="col" title="#"></th>
                    <th scope="col" title="{{'TABLE.HEADER.PERSON' | translate }}"></th>
                    <th scope="col" title="{{'TABLE.HEADER.URL' | translate }}"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let person of people; let index = index">
                    <td title="#" class="font-weight-bold">{{index + 1}}</td>
                    <td title="{{'TABLE.HEADER.PERSON' | translate }}">{{person.fullname | translate}}</td>
                    <td title="{{'TABLE.HEADER.URL' | translate }}">
                        <button class="btn-sm btn btn-success" *ngIf="!isOperationComplete(person)"
                                (click)="resend(person)"><i
                                class="fa fa-envelope"></i> Reenviar
                        </button>
                        <span *ngIf="isOperationComplete(person)">No disponible
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" data-dismiss="alert" aria-label="Close"
                class="btn btn-outline-success"
                (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
